<template>
  <div class="success">
    <div class="success-icon"><icon icon-class="xuanze"></icon></div>
    <div class="success-title">购买成功</div>
    <div class="success-info">
      <div>订单编号 {{orderId}}</div>
      <template v-if="isFestival">
        <div class="warn">因春节快递停运，即日起暂停发货</div>
        <div class="warn">2020年2月3日后恢复发货</div>
      </template>
      <div v-else>将在3个工作日内发出，请注意查收</div>
      <div>如有疑问，请联系</div>
      <div>凯诺官方咨询QQ 2917824355</div>
    </div>
    <div class="success-button"><button class="back-button" @click="back">回首页</button></div>
  </div>
</template>

<style lang="less" scoped>
  .success{
    width: 100%;
    padding-top: 24px;
    text-align: center;
    svg{
      font-size: 64px;
      color: #53B488;
    }
    .success-title{
      margin-top: 24px;
      font-size: 24px;
      line-height: 28px;
      color: #333;
    }
    .success-info{
      margin-top: 12px;
      font-size: 14px;
      line-height: 21px;
      color: #666;
    }
    .success-info .warn{
      color: #F85C5C;
    }
    .success-button{
      width: 315px;
      margin: 36px auto 0;
    }
    .success-button button{
      width: 100%;
      height: 42px;
      line-height: 42px;
      background-color: @cano;
      border-radius: 25px;
      color: #FFF;
      font-size: 16px;
      transition: all .2s;
      border: 0;
      &:active{
        opacity: .8;
      }
    }
  }
</style>

<script type="text/javascript">
  export default {
    data() {
      return {
        isFestival: false,
        orderId: this.$route.query.oid
      }
    },
    methods: {
      back() {
        this.$router.push('/');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Book/success.vue